import { useState, useEffect } from "react";
import { Modal, Select, Button, Space, Collapse } from "antd";
import { FilterOutlined, ClearOutlined } from "@ant-design/icons";
import {
  PRICE_OPTIONS,
  BEDS_OPTIONS,
  BATHS_OPTIONS,
  SQFT_OPTIONS,
  LOT_SIZE_OPTIONS,
  YEAR_OPTIONS,
  DEFAULT_FILTERS,
  hasActiveFilters,
} from "../../constants/whiteboardConstants";

const { Panel } = Collapse;

const WhiteboardFilter = ({ filters, onFilterChange, onClearFilters }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [localFilters, setLocalFilters] = useState(filters);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const handleApply = () => {
    onFilterChange(localFilters);
    setIsModalOpen(false);
  };

  const handleClear = () => {
    setLocalFilters(DEFAULT_FILTERS);
    onClearFilters();
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setLocalFilters(filters); // Reset to current filters
    setIsModalOpen(false);
  };

  const isFiltered = hasActiveFilters(filters);

  return (
    <>
      <Button
        icon={<FilterOutlined />}
        onClick={() => setIsModalOpen(true)}
        type={isFiltered ? "primary" : "default"}
        style={isFiltered ? { backgroundColor: "#b4c540", borderColor: "#b4c540", color: "#fff" } : {}}
      >
        {isFiltered ? "Filtered" : "Filter"}
      </Button>

      <Modal
        title="Filter Listings"
        open={isModalOpen}
        onCancel={handleCancel}
        width={500}
        footer={[
          <Button key="clear" icon={<ClearOutlined />} onClick={handleClear}>
            Reset
          </Button>,
          <Button key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="apply"
            type="primary"
            onClick={handleApply}
            style={{ backgroundColor: "#b4c540", borderColor: "#b4c540", color: "#fff" }}
          >
            Apply
          </Button>,
        ]}
      >
        <div className="space-y-4 py-2">
          {/* Price Range */}
          <div>
            <label className="block font-medium mb-2">Price</label>
            <Space>
              <Select
                style={{ width: 140 }}
                placeholder="No Min"
                value={localFilters.minPrice}
                onChange={(value) =>
                  setLocalFilters({ ...localFilters, minPrice: value })
                }
                options={PRICE_OPTIONS}
                allowClear
              />
              <span className="text-gray-400">to</span>
              <Select
                style={{ width: 140 }}
                placeholder="No Max"
                value={localFilters.maxPrice}
                onChange={(value) =>
                  setLocalFilters({ ...localFilters, maxPrice: value })
                }
                options={PRICE_OPTIONS}
                allowClear
              />
            </Space>
          </div>

          {/* Beds & Baths */}
          <div className="flex gap-6">
            <div>
              <label className="block font-medium mb-2">Beds</label>
              <Select
                style={{ width: 100 }}
                value={localFilters.beds}
                onChange={(value) =>
                  setLocalFilters({ ...localFilters, beds: value })
                }
                options={BEDS_OPTIONS}
              />
            </div>
            <div>
              <label className="block font-medium mb-2">Baths</label>
              <Select
                style={{ width: 100 }}
                value={localFilters.baths}
                onChange={(value) =>
                  setLocalFilters({ ...localFilters, baths: value })
                }
                options={BATHS_OPTIONS}
              />
            </div>
          </div>

          {/* Collapsible sections */}
          <Collapse ghost>
            {/* Square Feet */}
            <Panel header="Square Feet" key="sqft">
              <Space>
                <Select
                  style={{ width: 120 }}
                  placeholder="No Min"
                  value={localFilters.minsqFt}
                  onChange={(value) =>
                    setLocalFilters({ ...localFilters, minsqFt: value })
                  }
                  options={SQFT_OPTIONS}
                  allowClear
                />
                <span className="text-gray-400">to</span>
                <Select
                  style={{ width: 120 }}
                  placeholder="No Max"
                  value={localFilters.maxsqFt}
                  onChange={(value) =>
                    setLocalFilters({ ...localFilters, maxsqFt: value })
                  }
                  options={SQFT_OPTIONS}
                  allowClear
                />
              </Space>
            </Panel>

            {/* Lot Size */}
            <Panel header="Lot Size" key="lotSize">
              <Space>
                <Select
                  style={{ width: 120 }}
                  placeholder="No Min"
                  value={localFilters.minLotSize}
                  onChange={(value) =>
                    setLocalFilters({ ...localFilters, minLotSize: value })
                  }
                  options={LOT_SIZE_OPTIONS}
                  allowClear
                />
                <span className="text-gray-400">to</span>
                <Select
                  style={{ width: 120 }}
                  placeholder="No Max"
                  value={localFilters.maxLotSize}
                  onChange={(value) =>
                    setLocalFilters({ ...localFilters, maxLotSize: value })
                  }
                  options={LOT_SIZE_OPTIONS}
                  allowClear
                />
              </Space>
            </Panel>

            {/* Year Built */}
            <Panel header="Year Built" key="year">
              <Space>
                <Select
                  style={{ width: 120 }}
                  placeholder="No Min"
                  value={localFilters.minYearBuilt}
                  onChange={(value) =>
                    setLocalFilters({ ...localFilters, minYearBuilt: value })
                  }
                  options={YEAR_OPTIONS}
                  allowClear
                />
                <span className="text-gray-400">to</span>
                <Select
                  style={{ width: 120 }}
                  placeholder="No Max"
                  value={localFilters.maxYearBuilt}
                  onChange={(value) =>
                    setLocalFilters({ ...localFilters, maxYearBuilt: value })
                  }
                  options={YEAR_OPTIONS}
                  allowClear
                />
              </Space>
            </Panel>
          </Collapse>
        </div>
      </Modal>
    </>
  );
};

export default WhiteboardFilter;
